import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { GET_TASK_TEMPLATES_BY_COMPANY } from './get-task-templates-by-company.hook';

export const DELETE_TASK_TEMPLATE = gql`
  mutation deleteTaskTemplateById($taskTemplateId: String!) {
    deleteTaskTemplateById(taskTemplateId: $taskTemplateId)
  }
`;

export const useDeleteTaskTemplate = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation('common');

  const [deleteTaskTemplate] = useMutation(DELETE_TASK_TEMPLATE, {
    onCompleted: onSuccess,
    onError: () =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('notifications.error.title'),
        description: t('notifications.error.subTitle'),
      }),
    refetchQueries: [GET_TASK_TEMPLATES_BY_COMPANY],
  });

  return deleteTaskTemplate;
};
